import { Component, HostListener, OnInit } from '@angular/core';

import { GridApi } from 'ag-grid-community';
import { NgxSpinnerService } from 'ngx-spinner';
import { ActionsComponent } from 'src/app/cell-renderer/actions/actions.component';
import { LoadingGridComponent } from 'src/app/cell-renderer/loading-grid/loading-grid.component';
import { DriverService } from 'src/app/services/driver.service';
import { UtilsService } from 'src/app/services/utils.service';
import { HttpEventType } from '@angular/common/http';
import Swal from 'sweetalert2';

declare const $: any

@Component({
    selector: 'app-driver-list',
    templateUrl: './driver-list.component.html',
    styleUrls: ['./driver-list.component.css']
})
export class DriverListComponent {
    constructor(private apiDriver: DriverService, private utils: UtilsService, private spinner: NgxSpinnerService) { }
    address: any = []

    private importing = false;

    public actionsOpen = false;

    columnDefs = [
        { headerName: "Accion", width: 95, cellRenderer: ActionsComponent, cellRendererParams: { parent: this, url_edit: "/driver/update/", module: "Conductores", singular_module: "Conductor" } },
        {
            headerName: "Datos Personales", children: [
                { field: 'name', headerName: "Nombre" },
                { field: 'last_name', headerName: "Apellidos" },
                { field: 'cell_phone', headerName: "Celular" },
                { field: 'birthday_date', headerName: "Fecha Nacimiento" },
                { field: 'municipality', headerName: "Alcaldia o municipio" },

            ]
        }, {
            headerName: "Datos Bancarios", children: [
                { field: 'bank_data.holder_name', headerName: "Nombre del Titular" },
                { field: 'bank_data.bank_name', headerName: "Banco" },
                { field: 'bank_data.account_number', headerName: "Numero de Cuenta o Tarjeta" },
                { field: 'bank_data.account_type', headerName: "Tipo de Cuenta" }
            ]
        }
    ];

    public loadingCellRenderer: any = LoadingGridComponent;
    public loadingCellRendererParams: any = {
        loadingMessage: 'Espere un momento...',
    };

    public defaultColDef = {
        sortable: true,
        filter: true,
    };

    private gridApi!: GridApi;

    public rowData: any = [];

    ngOnInit(): void {
    }

    event_text = ''

    onGridReady(params: any) {
        this.spinner.show()
        this.apiDriver.listDriver().subscribe((resp) => {
            this.rowData = resp;
            this.spinner.hide()
        })
    }

    toggleActionsDropdown() {
        this.actionsOpen = !this.actionsOpen;
    }

    closeActionsDropdown() {
        this.actionsOpen = false;
    }

    @HostListener('document:click')
    onDocumentClick() {
        this.closeActionsDropdown();
    }

    exportCsv() {
        this.spinner.show();
        this.apiDriver.exportDrivers().subscribe({
            next: (blob: any) => {
                this.spinner.hide();
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = `drivers-export-${new Date().toISOString().slice(0, 19).replace(/[:T]/g, '-')}.csv`;
                a.click();
                window.URL.revokeObjectURL(url);
            },
            error: () => {
                this.spinner.hide();
                this.utils.alertSwal({ title: 'Error', text: 'No se pudo exportar el CSV', icon: 'error' });
            }
        })
    }

    openCsvPicker(input: HTMLInputElement) {
        if (this.importing) {
            return;
        }
        this.closeActionsDropdown();
        input.value = '';
        input.click();
    }

    onCsvSelected(event: Event) {
        const input = event.target as HTMLInputElement;
        const file = input?.files?.[0];
        if (!file) {
            return;
        }
        this.importCsv(file);
    }

    private importCsv(file: File) {
        this.importing = true;

        Swal.fire({
            title: 'Importando conductores',
            html: `
                <div style="text-align:left">
                  <div style="margin-bottom:8px">Subiendo archivo y procesando…</div>
                  <div style="width:100%;background:#e9ecef;border-radius:6px;overflow:hidden;height:12px">
                    <div id="importProgressBar" style="width:0%;height:12px;background:#0d6efd"></div>
                  </div>
                  <div id="importProgressText" style="margin-top:8px;font-size:12px;color:#6c757d">0%</div>
                </div>
            `,
            allowOutsideClick: false,
            allowEscapeKey: false,
            showConfirmButton: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        this.apiDriver.importDrivers(file).subscribe({
            next: (event) => {
                if (event.type === HttpEventType.UploadProgress) {
                    const total = event.total ?? 0;
                    const loaded = event.loaded ?? 0;
                    const percent = total > 0 ? Math.round((loaded / total) * 100) : 0;
                    const bar = document.getElementById('importProgressBar');
                    const txt = document.getElementById('importProgressText');
                    if (bar) bar.style.width = `${percent}%`;
                    if (txt) txt.textContent = `${percent}%`;
                }

                if (event.type === HttpEventType.Response) {
                    const resp: any = event.body;
                    Swal.close();

                    const summary = resp?.summary;
                    const errors = resp?.errors ?? [];
                    const inserted = summary?.inserted ?? 0;
                    const updated = summary?.updated ?? 0;
                    const failed = summary?.failed ?? 0;

                    const html = `
                      <div style="text-align:left">
                        <div><strong>Insertados:</strong> ${inserted}</div>
                        <div><strong>Actualizados:</strong> ${updated}</div>
                        <div><strong>Fallidos:</strong> ${failed}</div>
                      </div>
                    `;

                    Swal.fire({
                        title: 'Importación finalizada',
                        html,
                        icon: failed > 0 ? 'warning' : 'success',
                        showCancelButton: failed > 0,
                        confirmButtonText: 'Aceptar',
                        cancelButtonText: failed > 0 ? 'Descargar errores' : undefined,
                    }).then((result) => {
                        if (result.dismiss === Swal.DismissReason.cancel && failed > 0) {
                            this.downloadJson(errors, 'driver-import-errors.json');
                        }
                    });

                    this.onGridReady({});
                    this.importing = false;
                }
            },
            error: (error) => {
                Swal.close();
                this.importing = false;
                this.utils.alertSwal({ title: 'Error', text: String(error || 'Error al importar'), icon: 'error' });
            }
        });
    }

    private downloadJson(data: any, filename: string) {
        try {
            const blob = new Blob([JSON.stringify(data, null, 2)], { type: 'application/json;charset=utf-8' });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = filename;
            a.click();
            window.URL.revokeObjectURL(url);
        } catch (e) {
        }
    }

    actionDelete(id: number) {
        this.utils.alertSwalConfir({title:"Eliminación", text:"Esta seguro que desea eliminar el conductor seleccionado", icon: "warning", btn_confirm: "Elimniar"})
        .then((result) => {
            if(result.isConfirmed){
                this.spinner.show()
                this.apiDriver.deleteDriver(id).subscribe((resp) => {
                    this.spinner.hide()
                    this.utils.alertSwal({title: "Operación Exitosa", text: "Se ha realizado la eliminacion del conductor de forma exitosa", icon: "success"})
                    this.onGridReady({})
                }, (error) => {
                    this.spinner.hide()
                    this.utils.alertSwal({title: "Error", text: "Se ha presentado un error al intentar eliminar el conductor", icon: "error"})
                })
                
            }
        })
    }
}
